import BaseUseCase from "../../../base_use_case.js.jsx";

class ShowMainStatisticsUseCase extends BaseUseCase {

  execute() {
    return this.httpClient({
      ...this.requestConfig(),
      method: "get",
      url: `/api/v1/admin/statistics/main`,
    });
  }
}

const instance = new ShowMainStatisticsUseCase();
export default instance;